module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#filter",
      toString: function () {
        return this.url;
      }
    }